<template>
  <div id="liveDPlayer" @dblclick="fullScreen"></div>
</template>

<script>
import flvjs from 'flv.js'
import DPlayer from 'dplayer';

export default {
  props: {
    live_Options: Object,
  },
  data() {
    return {
      isFullScreen: false,
    };
  },
  methods: {
    initDPlayer(live_Options) {
      // console.log(live_Options)
      const options = {
        container: document.getElementById("liveDPlayer"),
        autoplay: true,
        screenshot: true,
        hotkey: false,
        live: true,
        volume: 0,
        video: {
          url:live_Options.play_url,
          type: "customFlv",
          customType: {
            customFlv: function (video, player) {
              const flvPlayer = flvjs.createPlayer({
                type: "flv",
                url: video.src,
              });
              flvPlayer.attachMediaElement(video);
              flvPlayer.load();
            },
          },
        }
      }
  
      // this.player.swichVideo({ url }); //切换只能用这个方式，不能直接修改options
      this.player = new DPlayer(options);
    },
    fullScreen() {
      if(this.isFullScreen){
        this.player.fullScreen.cancel('browser');
        this.isFullScreen = false;
      }else{
        this.player.fullScreen.request('browser');
        this.isFullScreen = true;
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initPlayer(this.live_Options);
    // });
    setTimeout(() => {
      this.initDPlayer(this.live_Options);
    },500)
  },
}
</script>
<style scoped>
:deep(#liveDPlayer ){
  height: 100%;
  .dplayer-video-current {
    /* width: auto; */
    height: 100%;
    margin: 0 auto;
  }
  .dplayer-video-wrap {
    height: 100%;
  }
  .dplayer-video {
    height: 100%;
  }
}

</style>